import { useEffect, useState } from 'react'

/**
 * Debounce a rapidly-changing value.
 *
 * Used where the value feeds a query key: the Library rail (a fast click burst
 * would fire a `/facet/batch` call per toggle) and the audit log's entity-id
 * field (pasting a UUID would fire one request per character).
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
	const [debounced, setDebounced] = useState(value)
	useEffect(() => {
		const id = setTimeout(() => setDebounced(value), delayMs)
		return () => clearTimeout(id)
	}, [value, delayMs])
	return debounced
}
